import React from 'react';
import Iconography, { IconographySizes } from '@hid-galaxy-ui/galaxy-react/components/Iconography';
import { getTranslation } from './functions';
import { NotificationVariant } from '@hid-galaxy-ui/galaxy-react/components/Notification/notificationEnums';

export const NotificationSuccess = (
  title: string,
  messageKey = null,
  key = 'notification-success',
  notifications = [],
) => {
  return [
    ...notifications,
    {
      id: key,
      title: getTranslation(title),
      variant: NotificationVariant.Success,
      icon: <Iconography icon="circleCheck" size={IconographySizes.Medium} />,
      message: getMessage(messageKey),
    },
  ];
};
export const NotificationError = (
  title: string,
  key = 'notification-error',
  notifications = [],
  messageKey = null,
  expanded = false,
) => {
  return [
    ...notifications,
    {
      id: key,
      title: getTranslation(title),
      variant: NotificationVariant.Error,
      icon: <Iconography icon="ban" size={IconographySizes.Medium} />,
      message: getMessage(messageKey),
      expanded: expanded,
    },
  ];
};

export const NotificationWarning = (
  message: string,
  key = 'notification-warning',
  notifications = [],
) => {
  return [
    ...notifications,
    {
      id: key,
      title: getTranslation('WARNING'),
      message: message,
      variant: NotificationVariant.Warning,
      icon: <Iconography icon="circleExclamation" size={IconographySizes.Medium} />,
    },
  ];
};

const getMessage = (messageKey: string | null): string | null =>
  messageKey ? getTranslation(messageKey) : null;
